// extracted by mini-css-extract-plugin
export default {"input":"input_input__g5nKz","error":"input_error__LGbk8"};